import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import API from '@sesame/web-api';

import { Spinner } from 'src/components/Spinner';
import { ILoadState, IRack, IRackComponent, IComponent, ISalesorder } from 'src/types';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';
import { RackSerialComponents } from './RackSerialComponents';


export default function RackSerials() {
  const  {isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const [rack, setRack] = useState<IRack>();
  const [rackId, setRackId] = useState(0);
  const [displayState, setDisplayState] = useState<ILoadState>(ILoadState.NEW);
  const [salesorder, setSalesorder] = useState('')
  const [imgUpdateKey, setImgUpdateKey] = useState(1);

  const getRack = async (reqRackId: number) => {
    const accessToken = await getAccessTokenSilently();
    const resp = await API.get(accessToken, `/api/v1/rack/${reqRackId}`)
      .catch(err => {
        setDisplayState(ILoadState.ERROR);
      });
    const newRack = resp.data as IRack;
    setRack(newRack);
    setRackId(newRack.rackId);
    getSalesorder(newRack.salesorderId);
    setDisplayState(ILoadState.READY);
  }

  const getSalesorder = async (salesorderId: number) => {
    const accessToken = await getAccessTokenSilently();
    const resp = await API.get(accessToken, `/api/v1/salesorder/${salesorderId}`)
    const salesorder = resp.data as ISalesorder;
    setSalesorder(salesorder.salesorderRef);
  }

  const onElevationChange = () => {
    setTimeout(() => setImgUpdateKey(Date.now()), 100);
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const queryRackId = parseInt(queryParams.get('rack') || '0');
    getRack(queryRackId);
  }, [getAccessTokenSilently]);

  if (isLoading || displayState == ILoadState.NEW || displayState == ILoadState.LOADING || !rack) {
    return <div className="uk-container uk-align-center">
      <br />
      <br />
      <Spinner />
    </div>
  }
  if (displayState == ILoadState.ERROR) {
    return <div className="uk-container">
      <h2>Rack</h2>
      <p>Error loading rack</p>
    </div>
  }
  return <div className="uk-container uk-width-1-1">
    <h1>Rack Management</h1>
    {rack.identifier} - {rack.bomPartNumber} : {rack.revision}
    <br />
    {rack.description}
    <br />
    Sales Order: <a href={`/editSalesOrder?salesorder=${rack.salesorderId}`}>{salesorder}</a>
    <br />
    <div data-uk-grid>
      <div className="uk-width-2-3">
        <RackSerialComponents rackId={rackId} onElevationChange={onElevationChange} />
      </div>
      <div className="uk-width-expand@m">
        <img src={`/api/v1/rack/${rack.rackId}/elevation#key=${imgUpdateKey}`} />
      </div>
    </div>
  </div>
};
